
///客户端是pc端还是移动端
export function isPC(){  
  const flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|huawei|Android|oppo|vivo|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
  return !flag
}

///非pc端，满足600<=最短部分<=1280判断为平板
export function isTablet(){
  let min=Math.min(window.innerWidth,window.innerHeight)
  return isPC() ? false : min>=600&&min<=1280
}

///非pc端，满足600<=最短部分<=1280判断为平板
export function isShowOrientation(){
  return isTablet() ? window.innerWidth < window.innerHeight : false
}


///客户端是平板（部分）
export function isPad(){  
  var ua = navigator.userAgent,
  isAndroid = /(?:Android)/.test(ua),
  isFireFox = /(?:Firefox)/.test(ua),
  isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua));
  var IsIPad = false
  if (/ipad/i.test(ua)) {
    IsIPad = true
  }
  // iPad from IOS13
  var macApp = ua.match(/Macintosh/i) != null
  if (macApp) {
    // need to distinguish between Macbook and iPad
    var canvas = document.createElement('canvas')
    if (canvas != null) {
      var context =
        canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
      if (context) { 
        var info = context.getExtension('WEBGL_debug_renderer_info')
        if (info) {
          var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL)
          if (renderer.indexOf('Apple') != -1) IsIPad = true
        }
      }
    }
  }
  return IsIPad||isTablet;
}

///数字小数点

export function toFixed(number, m) {
    if (typeof number !== "number") {
      throw new Error("number不是数字");
    }
    let result = Math.round(Math.pow(10, m) * number) / Math.pow(10, m);
    result = String(result);
    if (result.indexOf(".") == -1) {
      if (m != 0) {
        result += ".";
        result += new Array(m + 1).join("0");
      }
    } else {
      let arr = result.split(".");
      if (arr[1].length < m) {
        arr[1] += new Array(m - arr[1].length + 1).join("0");
      }
      result = arr.join(".");
    }
    return result;
  }
  
  export function integralComputation(point, pet){
       
    return  Math.round(point / pet) 
     
  }
  export function  MathRound(value){
       
    return  parseInt(value) 
     
  }
  
  ///判断输入值是否为正整数
export function isPositiveInteger(s){
  
  if((/(^[1-9]\d*$)/.test(s))) {
     return  true
  } else {
    return false
  }
}    

///转换为了大写字符
export function stringToUpperCase(value){
   return value.toUpperCase()
}

export function setupDocumentEvent() {
  // 禁止 ios 缩放屏幕
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault();
  });

  // 禁止移动端（IOS）双击页面变大
  let touchTime = 0;
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener(
    'touchend',
    function (event) {
      //记录当前点击的时间与下一次时间的间隔
      const nowTime = new Date();
      if (nowTime.getTime() - touchTime <= 300) {
        event.preventDefault();
      }
      touchTime = nowTime.getTime();
    },
    false
  );
}